import { APP_INITIALIZER, EnvironmentProviders, isDevMode, makeEnvironmentProviders } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
import {
  LocalizationService,
  MDS_TRANSLATE_LOADERS,
  TranslateDateAdapterService,
  TranslateMultiLoaderService,
} from '@mds/ngx-core';
import { LayoutTranslationLoader } from '@mds/ngx-layout';
import { WebpackTranslateLoader } from '../config/translate-loader';

export function provideTranslations(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: MDS_TRANSLATE_LOADERS, useClass: WebpackTranslateLoader, multi: true },
    { provide: MDS_TRANSLATE_LOADERS, useClass: LayoutTranslationLoader, multi: true },
    provideTransloco({
      config: {
        availableLangs: ['en'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        flatten: {
          aot: false,
        },
      },
      loader: TranslateMultiLoaderService,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: (localizationService: LocalizationService) => () => localizationService.init(),
      deps: [LocalizationService],
      multi: true,
    },
    provideTranslocoLocale({
      localeConfig: {
        global: {
          decimal: {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          },
        },
      },
      langToLocaleMapping: {
        en: 'en-CH',
      },
      defaultLocale: 'en-CH',
    }),
    { provide: DateAdapter, useClass: TranslateDateAdapterService },
  ]);
}
